import { useMemo } from 'react';
import { useInstructionalLevelsList } from '../../../../hooks/instructionalLevel/useInstructionalLevelsList.js';
import InstructionalLevelTable from '../../../../components/tables/unitsLevels/InstructionalLevelTable.jsx';
import SearchBar from '../../../../components/utils/SearchBar.jsx';
import Pagination from '../../../../components/utils/Pagination.jsx';
import ErrorModal from '../../../../components/modales/ErrorModal.jsx';

export default function ListInstructionalLevels() {
    // Traer listas
    const {
        instructionalLevels,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        handleSort
    } = useInstructionalLevelsList();

    // FILTRO POR BÚSQUEDA
    const filteredInstructionalLevels = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return instructionalLevels.filter(instructionalLevel => {
            return (
                (instructionalLevel.name || '').toLowerCase().includes(search));
        });
    }, [instructionalLevels, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentInstructionalLevels = filteredInstructionalLevels.slice(indexOfFirstItem, indexOfLastItem);
  
    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'>Niveles instruccionales</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />
                <InstructionalLevelTable
                    instructionalLevels={currentInstructionalLevels}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                />
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredInstructionalLevels.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}